import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import classnames from 'classnames'

import { giftSubscriptionDispatchers as mergeSelector } from 'reduxModules/subscriptions/dispatchers'
import { authInfoReselector as stateSelector } from 'reduxModules/auth/selectors'

import subscriptionPlans from '../../SubscriptionPlans/fixturePlans'
import EMAIL_PATTERN from '../../utils/emailPattern'
import InlineError, { ariaErrorProps } from '../../generic/InlineError'
import '../../generic/RenderedField/styles.css'
import './styles.css'


export function GiftSubscription({ onSubmit, subscription = null }) {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm()

  const subscriptionType = () => {
    const planIds = subscriptionPlans.map((sub) => sub.id)
    if (planIds.includes(subscription.planId))
      return subscription.planId === 4 ? 'Year' : 'Month'
    return 'subscription'
  }

  return (
    <div id="GiftSubscription" className="account-section">
      <h3 className="account-section__title">Gift a Subscription</h3>
      <div className="gift-subscription-wrapper">
        <div className="gift-subscription-box">
          <div className="subheading">
            Congrats! You are able to gift (1) {subscriptionType()} of the {subscription.plan} subscription
          </div>
          <form id="GiftSubscriptionForm" onSubmit={handleSubmit(onSubmit)}>
            <div className={classnames('field', '-floating', { '-error': errors.gifterName })}>
              <div className="field-container">
                <input
                  {...register('gifterName', {
                    required: 'This field is required.'
                  })}
                  type="text"
                  placeholder=" "
                  id="gift-gifter-name"
                  {...ariaErrorProps('gift-gifter-name', errors.gifterName)}
                />
                <label htmlFor="gift-gifter-name">Your Name</label>
                <InlineError
                  id="gift-gifter-name"
                  message={errors.gifterName?.message}
                />
              </div>
            </div>
            <div className="send-text">Send subscription to: </div>
            <div className="input-names">
              <div className={classnames('field', '-floating', { '-error': errors.firstName })}>
                <div className="field-container">
                  <input
                    {...register('firstName', {
                      required: 'This field is required.'
                    })}
                    type="text"
                    placeholder=" "
                    id="gift-first-name"
                    {...ariaErrorProps('gift-first-name', errors.firstName)}
                  />
                  <label htmlFor="gift-first-name">First Name</label>
                  <InlineError
                    id="gift-first-name"
                    message={errors.firstName?.message}
                  />
                </div>
              </div>
              <div className={classnames('field', '-floating', { '-error': errors.lastName })}>
                <div className="field-container">
                  <input
                    {...register('lastName', {
                      required: 'This field is required.'
                    })}
                    type="text"
                    placeholder=" "
                    id="gift-last-name"
                    {...ariaErrorProps('gift-last-name', errors.lastName)}
                  />
                  <label htmlFor="gift-last-name">Last Name</label>
                  <InlineError
                    id="gift-last-name"
                    message={errors.lastName?.message}
                  />
                </div>
              </div>
            </div>
            <div className={classnames('field', '-floating', { '-error': errors.email })}>
              <div className="field-container">
                <input
                  {...register('email', {
                    required: 'This field is required.',
                    pattern: {
                      value: EMAIL_PATTERN,
                      message: 'Invalid email address.'
                    }
                  })}
                  type="email"
                  placeholder=" "
                  id="gift-email"
                  {...ariaErrorProps('gift-email', errors.email)}
                />
                <label htmlFor="gift-email">Email</label>
                <InlineError
                  id="gift-email"
                  message={errors.email?.message}
                />
              </div>
            </div>
            <textarea
              {...register('message')}
              placeholder="Message"
              aria-label="Message"
            />
            <button type="submit" className="btn -wide submit-btn">
              Send Gift
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

GiftSubscription.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  subscription: PropTypes.shape({
    free: PropTypes.bool,
    rank: PropTypes.number,
    plan: PropTypes.string,
    planId: PropTypes.number
  })
}

export default connect(
  stateSelector,
  null,
  mergeSelector
)(GiftSubscription)
